import React from 'react'
import './RenewCertification.css'
import RenewedCertificationTable from '../../components/Renewed certifications/RenewedCertificationTable'
const RenewCertificationMainPage = () => {
  return (
    <div>
       <RenewedCertificationTable/>
    </div>
  )
}

export default RenewCertificationMainPage
